import react, { useState } from "react";
import ComponentCard from "../../../../components/common/ComponentCard";
import Button from "../../../../components/ui/button/Button";
import { useNavigate } from "react-router-dom";
import Form from "../../../../components/form/Form";
import Label from "../../../../components/form/Label";
import Select from "../../../../components/form/Select";
import Input from "../../../../components/form/input/InputField";
import Switch from "../../../../components/form/switch/Switch";

const apiUrl = process.env.REACT_APP_API_URL;

export default function AddNewWorkflowCategory() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    status: "",
    temperatureCheck: false,
  });

  const [errors, setErrors] = useState({
    name: "",
    status: "",
  });
  
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
      setErrors({
        ...errors,
        [e.target.name]: "",
      });
    };
  
    const handleSelectChange = (option: any) => {
      setFormData({
        ...formData,
        status: option,
      });
      setErrors({
        ...errors,
        status: "",
      });
    };
  
  const validate = () => {
    let newErrors: any = {};
    if (!formData.name.trim()) newErrors.name = "Workflow Categories name is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const token = localStorage.getItem("token");
      const payload = {
        name: formData.name,
        status: formData.status,
        temperatureCheck: formData.temperatureCheck,
      };
      console.log(payload);

      const response = await fetch(`${apiUrl}/workflows_categories`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        navigate("/workflow-categories");
      }  
    } catch (err) {
      console.error("Error:", err);
    }
    };
    const handleCancel = () => {
    navigate("/workflow-categories");
  };

  //Handle temperature check switch
  const handleTemperatureCheckChange = (checked: boolean) => {
    setFormData({
      ...formData,
      temperatureCheck: checked,
    });
  };
  
  return(
    <>
      <ComponentCard title="Add New Workflow Category">
        <Form onSubmit={handleSubmit}>
          <>
            <div className="grid gap-6">
              <div className="col-span-full">
                <h4 className="pb-4 text-base font-medium text-gray-800 border-b border-gray-200 dark:border-gray-800 dark:text-white/90">
                  Workflow Category
                </h4>
              </div>
              {/* Venue Area Name */}
              <div>
                <Label>Workflow Category</Label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
              </div>


              {/* Record Status */}
              <div>
                <Label>Record Status</Label>
                <Select
                  options={[
                    { value: "current", label: "Current" },
                    { value: "non-current", label: "Non-Current" },
                  ]}
                  onChange={handleSelectChange}
                  className="mt-2 bg-gray-50 dark:bg-gray-800"
                />
              </div>

              {/* Auto Renewal Switch */}
              <Switch
                label="Temperature Check"
                checked={formData.temperatureCheck}
                onChange={(checked: boolean) => handleTemperatureCheckChange(checked)}
              />

              <div className="flex gap-3">
                <Button size="sm" type="submit">
                  Save Changes
                </Button>
                <Button size="sm" variant="outline" onClick={handleCancel} type="button">
                  Cancel
                </Button>
              </div>
            </div>
          </>
        </Form>
      </ComponentCard>
    
    </>
  )
};